/**
 * The personalisation fields come from the Globo Product Options app, which
 * injects them into the add-to-cart form at runtime. Dawn renders the quantity
 * selector as a sibling of that form, so the page reads
 * "Step 1, Step 2, Quantity, Step 3, name fields, Buy" - the quantity lands in
 * the middle of the personalisation steps.
 *
 * Move it into the buy button row, to the left of Buy, so the order is:
 * pick the options, personalise it, preview, then how many and buy in one
 * line.
 *
 * The quantity input carries a `form` attribute, so it still submits with the
 * cart form from anywhere in the document. If the app's markup is not present
 * the quantity is simply left where Dawn put it.
 */
(() => {
  const SELECTOR_QUANTITY = '.product__info-container > .product-form__quantity';
  const SELECTOR_BUTTONS = '.product-form__buttons';
  const TIMEOUT_MS = 6000;

  const place = () => {
    const quantity = document.querySelector(SELECTOR_QUANTITY);
    if (!quantity) return true; // Already moved, or this template has no quantity block.

    const buttons = document.querySelector(SELECTOR_BUTTONS);
    if (!buttons || !buttons.parentElement) return false;

    buttons.prepend(quantity);
    quantity.classList.add('product-form__quantity--inline');
    return true;
  };

  const start = () => {
    if (place()) return;

    // The app renders asynchronously; watch for the buy button to appear.
    const observer = new MutationObserver(() => {
      if (place()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), TIMEOUT_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
